import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { AuthProvider } from './auth/AuthProvider'
import { UsageBootstrap } from './components/UsageBootstrap'
import { DailyWorkCheckin } from './components/DailyWorkCheckin'
import { VisualTemplateProvider } from './components/VisualTemplateProvider'
import './styles.css'
import './operational.css'
import './operational-config.css'
import './global-search.css'
import './nova-lima-matriculas.css'
import './fique-em-dia.css'
import './dvcc.css'
import './empreendimentos-operacional.css'
import './qualificacoes.css'
import './acionamentos-operacional.css'
import './suite-help-operacional.css'
import './tabela-servicos-operacional.css'
import './irregularidades-operacional.css'
import './titularidade-flow.css'
import './implantacao-flow.css'
import './admin.css'
import './users-admin.css'
import './last-update.css'
import './usage-intelligence.css'
import './operational-intelligence.css'
import './daily-checkin.css'
import './announcements.css'
import './highlights.css'
import './performance.css'
import './performance-v52.css'
import './approved-round-fixes.css'
import './approved-icons.css'
import './startup-loader-visibility.css'
import './pages/admin/EmpreendimentosEditor.css'
import './visual-template.css'
import './visual-template-refinement.css'
import './visual-template-typography.css'
import './visual-template-final-polish.css'
import './visual-template-density.css'
import './visual-template-admin-premium.css'
import './visual-template-auto-gestao-nav.css'

import './modules/ativos-cx/ativos-cx.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <UsageBootstrap />
      <DailyWorkCheckin />
      <VisualTemplateProvider>
        <App />
      </VisualTemplateProvider>
    </AuthProvider>
  </StrictMode>,
)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined)
  })
}
